import { render, staticRenderFns } from "./limits.vue?vue&type=template&id=8eb6c8a6&scoped=true&"
import script from "./limits.vue?vue&type=script&lang=js&"
export * from "./limits.vue?vue&type=script&lang=js&"
import style0 from "./limits.vue?vue&type=style&index=0&id=8eb6c8a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb6c8a6",
  null
  
)

export default component.exports